<template lang="html">
    <header class="app-header">
        <!-- back button -->
        <v-btn flat @click="$router.go(-1)">
            <v-icon color="primary">arrow_back</v-icon>
        </v-btn>

        <search></search>

        <v-spacer></v-spacer>

        <div class="actions">
            <!-- actioons on header -- scan code bar & notifications -->
            <div class="header-actions">
                <v-btn flat @click="$eventHub.$emit('open-modal', Scan)">
                    <v-icon>mdi-barcode-scan</v-icon>
                </v-btn>
                <v-btn flat @click.stop="$eventHub.$emit('open-aside', Notifications)">
                    <v-badge overlap top>
                        <span slot="badge" v-if="notifs>0">{{notifs}}</span>
                        <v-icon>notifications</v-icon>
                    </v-badge>
                </v-btn>
            </div>
            <!-- user menu -- access admin apnel & deconnect -->
            <v-menu offset-y offset-x>
                <div slot="activator" class="user">
                    <avatar size="3rem" :item="data"></avatar>
                    <p>{{ data.first_name }}</p>
                    <v-icon>arrow_drop_down</v-icon>
                </div>
                <v-list class="user_menu">
                    <v-list-tile class="li">
                        <router-link :to="{ name: 'admin' }">
                            <v-icon>settings</v-icon>
                            Paramètres
                        </router-link>
                    </v-list-tile>
                    <v-list-tile @click="logout">
                        <v-icon>exit_to_app</v-icon>
                        Déconnexion
                    </v-list-tile>
                </v-list>
            </v-menu>
        </div>
    </header>
</template>

<script>
    import Avatar           from '../../components/avatar/Avatar.vue'
    import Search           from './Search'
    import Notifications    from '../../components/aside/Notifications'
    import Scan             from './Scan'

    export default {
        components: { Avatar, Search },
        data() {
            return {
                Notifications,
                notifs:0,
                interval:null,
                Scan
            }
        },

        computed: {
            data() {
                return this.$store.state.auth.user
            }
        },

        methods: {
            logout() {
                this.$store.dispatch('logout')
            },
            // get notifs method
            getNotifs(){
                this.axios.get(`/api/notification/count`)
                .then(response => {
                    this.notifs = response.data
                })
            }
        },
        mounted() {
            this.getNotifs()
            // get notifs at regular interval
            this.interval = setInterval(() => {
                this.getNotifs()
            }, 100000);
        },
        beforeDestroy () {
            clearInterval(this.interval)
        },
        created(){
            // when open notif panel, if counter notifs diff counter in header => update
            this.$eventHub.$on('update-notifs',() => {
                this.notifs > 0 ? this.notifs = this.notifs - 1 : this.notifs = 0
            })
            this.$eventHub.$on('update-total',(total) => {
                this.notifs = total
            })

        }
    }
</script>

<style lang="stylus" scoped>
    @require '../../assets/css/variables'

    header.app-header {
        position: fixed
        top: 0
        right: 0
        display: flex
        align-items: center
        justify-content: flex-end
        height: $app-header-height
        width: $app-header-width
        padding: 0
        background: $app-header-background
        z-index: -2
        //box-shadow: 0 0 33px 0 #EBEFF5
        //box-shadow: 0 2px 21px 0 #E3E4EC

        .actions {
            display: flex
            align-items: center
            height: 100%

            .header-actions {
                display: flex
                height: 100%
                .btn {
                    margin: 0
                    border-left: 1px solid $border-light-color
                    min-width: auto
                    height: 100%
                    & >>> div.btn__content{
                        padding: 0 2.5rem
                        i.icon {
                            padding: 0
                            font-size: 1.8rem
                            color: #707D90
                        }
                        .badge {
                            height: 100%
                            align-items: center
                            .badge__badge {
                                width: 1.5rem
                                height: 1.5rem
                                top: -5px
                                right: -8px
                                background-color: $primary-light-color!important
                                border-color: $primary-light-color!important
                                font-size: 1.2rem
                                font-weight: bold
                            }
                        }
                    }
                    &:last-of-type {
                        margin-right: 2rem
                        border-right: 1px solid $border-light-color
                    }
                }

            }

            .user {
                display: flex
                flex-wrap: wrap
                align-items: center
                width: 14rem

                p {
                    margin-bottom: 0
                    color: $text-color
                    font-size: 1.4rem
                    font-weight: 400
                    margin-left: 1rem
                }
            }
        }
    }

    .btn {
        margin: 0
        border-left: 1px solid $border-light-color
        min-width: auto
        height: 100%
        & >>> div.btn__content{
            padding: 0 2.5rem
            i.icon {
                padding: 0
                font-size: 1.8rem
                color: $text-color
            }
        }

        &:nth-child(2) {
            border-right: 1px solid $border-light-color
        }
    }

    .user_menu {
        .list__tile {
            font-weight: 400
            font-size: 1.5rem
        }
        a {
            text-decoration: none
            font-weight: 400
            font-size: 1.5rem
        }
    }
</style>



// WEBPACK FOOTER //
// src/layouts/app/Header.vue